// import styled from 'styled-components'
import { giphyDarkestGrey } from '@giphy/js-brand'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    height: 65px;
    background-color: ${giphyDarkestGrey};
    position: relative;
    display: flex;
    align-items: center;
    padding: 0px 15px;
    margin-top: 30px;
    box-sizing: border-box;
`
const Description = styled.span`
    font-weight: bold;

    span {
        font-weight: normal;
    }
`
const Support = styled.span`
    font-weight: bold;
    margin-left: auto;
`

const Emoji = styled.img`
    height: 45px;
    margin-right: 8px;
`

const RightArrow = styled.div`
    position: relative;
    top: 3px;
    display: inline-block;
`

const SupportCTA = () => (
    <Container>
        <Emoji src="https://media.giphy.com/media/USUIWSteF8DJoc5Snd/giphy.gif" />
        <Description>
            Have a feature request or bug to report? <span>Get in touch with GIPHY Support.</span>
        </Description>
        <Support>
            <a href="https://support.giphy.com/hc/en-us/requests/new">
                Contact Support <RightArrow className="ss-icon ss-navigateright" />
            </a>
        </Support>
    </Container>
)

export default SupportCTA
